import axios from "axios";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API,
    timeout: 30000,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

/* =====================================
   REQUEST INTERCEPTOR
===================================== */

axiosInstance.interceptors.request.use(
    (config) => {

        const token = localStorage.getItem("token");
        const business_id = localStorage.getItem("business_id");
        const business_user_id = localStorage.getItem("business_user_id");

        // Token
        if (token) {
            // Old API Support
            config.headers.token = token;

            // JWT Support
            config.headers.Authorization = `Bearer ${token}`;
        }

        // Business Id
        if (business_id) {
            config.headers.businessid = business_id;
        }

        // Business User Id
        if (business_user_id) {
            config.headers.businessuserid = business_user_id;
        }

        return config;

    },
    (error) => Promise.reject(error)
);

/* =====================================
   RESPONSE INTERCEPTOR
===================================== */

axiosInstance.interceptors.response.use(

    (response) => {

        console.log("Response :", response.data);

        return response;
    },

    (error) => {

        if (!error.response) {
            console.error("Network Error");
            return Promise.reject(error);
        }

        const { status, data } = error.response;

        switch (status) {

            case 400:
                console.error(data?.message || "Bad Request");
                break;

            case 401:
                console.error(data?.message || "Unauthorized");

                localStorage.clear();
                window.location.href = "/login";

                break;

            case 403:
                console.error(data?.message || "Forbidden");
                break;

            case 404:
                console.error(data?.message || "API Not Found");
                break;

            case 405:
                console.error(data?.message || "Method Not Allowed");
                break;

            case 408:
                console.error(data?.message || "Request Timeout");
                break;

            case 409:
                console.error(data?.message || "Conflict");
                break;

            case 422:
                console.error(data?.message || "Validation Error");
                break;

            case 429:
                console.error(data?.message || "Too Many Requests");
                break;

            case 500:
                console.error(data?.message || "Internal Server Error");
                break;

            case 502:
                console.error(data?.message || "Bad Gateway");
                break;

            case 503:
                console.error(data?.message || "Service Unavailable");
                break;

            default:
                console.error(data?.message || "Something went wrong");
                break;
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;